<template>
  <main class="page">
    <section class="section page__header">
      <div class="page__row page__row_between">
        <div class="page__item">
          <h1 class="title">Графики работы</h1>
        </div>
        <div class="table__buttons">
          <transition name="fade" v-if="roleAccessRemove">
            <AppButtonSmRemove
              v-if="isActiveDelete"
              title="Удалить"
              @click.stop.native="showRemoveConfirmationGroup"
              style="margin-right: 20px"
            />
          </transition>
          <AppButtonSmAdd 
            title="Создать" 
            @click.stop.native="showCreateModal" 
          />
        </div>
      </div>
    </section>

    <section class="section page__content">
      <div class="page__row mb-20" v-if="schedules.length !== 0">
        <AppTable :data="schedules"
                  :headers="tableHeaders.headers"
                  :has-checkbox="roleAccessRemove"
                  :all-items-active="tableHeaders.allActive"
                  :isMenuControlsActive="false"
                  @show-this-item="showUpdateModal"
                  @edit-this-item="showUpdateModal"
                  @toggle-active-item="toggleActiveItem"
                  @toggle-active-all="toggleActiveAll"
                  @remove-this-item="showRemoveConfirmation"
        />
      </div>
      <div class="page__row mb-20" v-else>
        <div class="no-records">
          <AppNoRecordsPlaceholder text="В разделе еще нет ни одной записи"/>
        </div>
      </div>
    </section>

    <section class="section page__footer directory-list__footer">
      <div class="page__row" v-if="pagination.lastPage > 1">
        <VPagination
          :pageList="pagination.pageList"
          :currentPage="pagination.currentPage"
          @get-page="getPage"
        />
      </div>
    </section>

    <transition name="fade" v-if="roleAccessRemove">
      <AppConfirmation 
        v-if="removeConfirmation.active"
        :text="removeConfirmation.group ? 'Вы действительно хотите удалить эти графики работы занятости?' : 'Вы действительно хотите удалить этот график работы?'"
        @confirm="removeConfirmation.group ? removeScheduleChecked() : removeSchedule()"
        @reject="closeRemoveConfirmation"
      />
      <AppModal 
        v-if="deleteResponseModal.isActive"
        :title="deleteResponseModal.title"
        :text="deleteResponseModal.text"
        confirmButtonTitle="Ок"
        :confirmButtonType="deleteResponseModal.type"
        @confirm="closeDeleteModal"
      />
    </transition>

    <transition-group name="fade">
      <ItemUpdateModal v-if="updateModal.active"
                       key="update-modal"
                       title="Редактировать график работы"
                       :item="updateModal.schedule"
                       :name-validation="updateModal.validation"
                       @set-item-name="setItemUpdatedName"
                       @update-item="updateItem"
                       @close-modal="closeModals"
      />
      <ItemCreateModal v-if="createModal.active"
                       key="create-modal"
                       title="Создать вид график работы"
                       :value="createModal.newScheduleName"
                       :name-validation="createModal.validation"
                       @set-item-name="setNewItemName"
                       @create-item="createItem"
                       @close-modal="closeModals"
      />
    </transition-group>
    <ThePagePreloader v-if="isLoading"/>
  </main>
</template>

<script>
import AppTable from '@/components/page/table/AppTable'
import AppConfirmation from '@/components/page/modal/AppConfirmation'
import AppButtonSmAdd from '@/components/page/button/AppButtonSmAdd'
import ThePagePreloader from '@/components/page/ThePagePreloader'
import ItemUpdateModal from '@/components/page/modal/itemUpdateModal'
import ItemCreateModal from '@/components/page/modal/itemCreateModal'
import AppNoRecordsPlaceholder from '@/components/page/text/AppNoRecordsPlaceholder'
import VPagination from '@/components/page/VPagination'
import AppButtonSmRemove from '@/components/page/button/AppButtonSmRemove'
import AppModal from '@/components/page/modal/AppModal'

export default {
  name: 'SchedulesList',
  components: {
    AppNoRecordsPlaceholder,
    ItemCreateModal,
    ItemUpdateModal,
    ThePagePreloader,
    AppButtonSmAdd,
    AppConfirmation,
    AppTable,
    AppButtonSmRemove,
    VPagination,
    AppModal
  },
  data () {
    return {
      removeConfirmation: {
        active: false,
        id: null,
        group: false
      }
    }
  },
  computed: {
    schedules () {
      return this.$store.getters.schedules.map(schedule => {
        return ({
          id: schedule.id,
          isActive: schedule.isActive,
          values: [
            schedule.name
          ]
        })
      })
    },
    isLoading () {
      return this.$store.getters.scheduleListIsLoading
    },
    tableHeaders () {
      return this.$store.getters.scheduleListTableHeaders
    },
    updateModal () {
      return this.$store.getters.scheduleListUpdateModal
    },
    createModal () {
      return this.$store.getters.scheduleListCreateModal
    },
    currentUser () {
      return this.$store.getters.currentUser
    },
    roleAccessRemove () {
      return this.$store.getters.getRoleRightsUsers.actions.remove
    },
    pagination () {
      return this.$store.getters.getScheduleListPagination
    },
    isActiveDelete () {
      return this.$store.getters.getScheduleListActiveDelete
    },
    deleteResponseModal () {
      return this.$store.getters.getScheduleListResponseModal
    }
  },
  methods: {
    toggleItemControls (itemId) {
      this.$store.dispatch('toggleScheduleListItemControls', itemId)
    },
    toggleActiveItem (itemId) {
      this.$store.dispatch('toggleScheduleListItemActive', itemId)
    },
    toggleActiveAll () {
      this.$store.dispatch('toggleScheduleListItemActiveAll')
    },
    showCreateModal () {
      this.$store.dispatch('showScheduleListCreateModal')
    },
    setNewItemName (name) {
      this.$store.dispatch('setCreatedScheduleName', name)
      this.$store.dispatch('clearScheduleListModalValidation')
    },
    createItem () {
      this.$store.dispatch('createSchedule')
    },
    showUpdateModal (itemId) {
      this.$store.dispatch('showScheduleListUpdateModal', itemId)
    },
    setItemUpdatedName (name) {
      this.$store.dispatch('setUpdatedScheduleName', name)
      this.$store.dispatch('clearScheduleListModalValidation')
    },
    updateItem () {
      this.$store.dispatch('updateSchedule')
    },
    showRemoveConfirmation (itemId) {
      this.removeConfirmation.active = true
      this.removeConfirmation.id = itemId
      this.removeConfirmation.group = false
    },
    showRemoveConfirmationGroup () {
      this.removeConfirmation.active = true
      this.removeConfirmation.id = null
      this.removeConfirmation.group = true
    },
    removeSchedule () {
      this.$store.dispatch('deleteSchedule', this.removeConfirmation.id)
      this.removeConfirmation.active = false
      this.removeConfirmation.id = null
    },
    removeScheduleChecked () {
      this.removeConfirmation.active = false
      this.$store.dispatch('deleteScheduleListCheckedItems')
    },
    closeRemoveConfirmation () {
      this.removeConfirmation.active = false
      this.removeConfirmation.id = null
    },
    closeDeleteModal () {
      this.$store.dispatch('closeScheduleListDeleteModal')
    },
    closeModals () {
      this.removeConfirmation.active = false
      this.removeConfirmation.id = null
      this.$store.dispatch('closeScheduleListModals')
      this.$store.dispatch('clearScheduleListModalValidation')
    },
    // pagination
    getPage (pageNum) {
      this.$store.dispatch('getScheduleListPage', pageNum)
    }
  },
  mounted () {
    this.$store.dispatch('getSchedules')
  },
  destroyed () {
    this.$store.commit('RESET_SCHEDULE_LIST_STORE')
  }
}
</script>

<style lang="scss" scoped>
.directory-list {
  &__footer {
    padding-bottom: 110px;
  }
}

.no-records {
  width: 100%;
  margin-top: 80px;
}
</style>
